module.exports = __webpack_public_path__ + "img/image 17.30c00b86.png";